import { ThemeProvider } from 'styled-components';
import { theme } from 'antd';

const Provider = ({ children }: React.PropsWithChildren) => {
  const { token } = theme.useToken();
  return <ThemeProvider theme={{ antd: token }}>{children}</ThemeProvider>;
};

export default Provider;
